module.exports = __webpack_public_path__ + "img/ms-symbollockup_mssymbol_19.319d9b9a.svg";